var map = {
	"./bidder/1.svg": 28901,
	"./bidder/2.svg": 97126,
	"./bidder/3.svg": 2455,
	"./bidder/4.svg": 57528,
	"./bidder/5.svg": 66537,
	"./managed/1.svg": 97370,
	"./managed/2.svg": 81833,
	"./managed/3.svg": 77592,
	"./managed/4.svg": 66775,
	"./managed/5.svg": 52390,
	"./managed/6.svg": 74821,
	"./managed/7.svg": 23652,
	"./managed/8.svg": 35347,
	"./selfserve/1.svg": 23418,
	"./selfserve/2.svg": 7881,
	"./selfserve/3.svg": 3640,
	"./selfserve/4.svg": 76471,
	"./selfserve/5.svg": 78438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90427;